webpackJsonp([2],{

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79);
module.exports = __webpack_require__(442);


/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
jQuery(document).ready(function () {
    new Frontend();
});
// tslint:disable-next-line cyclomatic-complexity
function createTooltip(e) {
    var citation = e.currentTarget;
    var existingTooltip = document.getElementById('abt-tooltip');
    if (existingTooltip) {
        existingTooltip.parentElement.removeChild(existingTooltip);
    }
    var rect = citation.getBoundingClientRect();
    var left = rect.left + rect.width / 2;
    var padding = 10;
    var margin = 10;
    var tooltip = document.createElement('div');
    tooltip.id = tooltip.className = 'abt-tooltip';
    tooltip.innerHTML = citation.dataset.citations;
    var callout = document.createElement('div');
    callout.className = 'abt-tooltip__callout';
    var buttonContainer = document.createElement('div');
    buttonContainer.className = 'abt-tooltip__close-button-container';
    buttonContainer.addEventListener('click', function () {
        return tooltip.parentElement.removeChild(tooltip);
    });
    var button = document.createElement('div');
    button.className = 'abt-tooltip__close-button';
    document.body.appendChild(tooltip);
    tooltip.appendChild(callout);
    tooltip.appendChild(buttonContainer);
    buttonContainer.appendChild(button);
    var tooltipWiderThanBody = tooltip.offsetWidth + margin + padding >= document.body.offsetWidth;
    var tooltipWouldOverflowLeft = padding + tooltip.offsetWidth / 2 > left;
    var tooltipWouldOverflowRight = left > document.body.offsetWidth / 2 && document.body.offsetWidth - left < padding + tooltip.offsetWidth / 2;
    var marginLeft = -1 * (tooltip.offsetWidth / 2) || 0;
    if (left + marginLeft < 0 || tooltipWiderThanBody) {
        tooltip.style.width = 'calc(100% - 25px)';
        tooltip.style.left = '10px';
    } else if (tooltipWouldOverflowRight) {
        tooltip.style.right = '5px';
        tooltip.style.marginRight = '5px';
    } else if (tooltipWouldOverflowLeft) {
        tooltip.style.left = left + 'px';
        tooltip.style.marginLeft = marginLeft + margin + 'px';
    } else {
        tooltip.style.left = left + 'px';
        tooltip.style.marginLeft = marginLeft + 'px';
    }
    if (tooltipWiderThanBody || tooltipWouldOverflowLeft) {
        callout.style.left = left - 10 - callout.offsetWidth / 2 + "px";
    } else if (tooltipWouldOverflowRight) {
        callout.style.right = document.body.offsetWidth - left - 20 + "px";
    } else {
        callout.style.left = "calc(50% - " + callout.offsetWidth / 2 + "px)";
    }
    if (rect.top - tooltip.offsetHeight < 0) {
        // On bottom - Upwards arrow
        tooltip.style.top = rect.bottom + window.pageYOffset + 10 + 'px';
        tooltip.classList.add('abt-tooltip_bottom');
        callout.classList.add('abt-tooltip__callout_up');
    } else {
        // On top - Downwards arrow
        tooltip.style.top = rect.top + window.pageYOffset - tooltip.offsetHeight - 10 + 'px';
        tooltip.classList.add('abt-tooltip_top');
        callout.classList.add('abt-tooltip__callout_down');
    }
    tooltip.classList.add('abt-tooltip_active');
}
exports.createTooltip = createTooltip;

var Frontend = function () {
    function Frontend() {
        var _this = this;

        _classCallCheck(this, Frontend);

        this.bibliography = document.querySelector('#abt-bibliography, #abt-smart-bib');
        if (!this.bibliography) {
            return;
        }
        this.itemContainer = document.getElementById('abt-bibliography__container') || this.bibliography;
        var citationList = document.querySelectorAll('.abt-citation, .abt_cite');

        var _arr = [].concat(_toConsumableArray(citationList));

        for (var _i = 0; _i < _arr.length; _i++) {
            var citation = _arr[_i];
            var reflist = JSON.parse(citation.dataset.reflist || '[]');
            citation.dataset.citations = reflist.map(function (id) {
                return _this.itemContainer.children.namedItem(id).outerHTML;
            }).join('');
            citation.addEventListener('click', createTooltip);
        }
        if (document.querySelector('.abt-bibliography__heading_toggle, #abt-smart-bib>h3.toggle')) {
            this.enableToggle();
        }
    }

    _createClass(Frontend, [{
        key: "enableToggle",
        value: function enableToggle() {
            var _this2 = this;

            var heading = document.querySelector('.abt-bibliography__heading_toggle');
            if (!this.itemContainer || !heading) return;
            var headingLevel = heading.dataset.headingLevel;
            if (headingLevel) {
                heading.style.font = this.getHeadingFont(headingLevel);
            }
            this.itemContainer.classList.add('abt-bibligraphy__container--hidden');
            heading.classList.add('abt-bibliography__heading_toggle--closed');
            heading.addEventListener('click', function () {
                heading.setAttribute('aria-expanded', JSON.stringify(heading.classList.contains('abt-bibliography__heading_toggle--closed')));
                heading.classList.toggle('abt-bibliography__heading_toggle--closed');
                _this2.itemContainer.classList.toggle('abt-bibligraphy__container--hidden');
            });
        }
    }, {
        key: "getHeadingFont",
        value: function getHeadingFont(headingLevel) {
            var tempHeading = document.createElement(headingLevel);
            tempHeading.style.display = 'none';
            document.body.appendChild(tempHeading);

            var _getComputedStyle = getComputedStyle(tempHeading),
                font = _getComputedStyle.font;

            document.body.removeChild(tempHeading);
            return font;
        }
    }]);

    return Frontend;
}();

Frontend.isTouchDevice = true === ('ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch);
exports.Frontend = Frontend;

/***/ })

},[237]);


// WEBPACK FOOTER //
// js/frontend.js